<template>
  <div class="zyc-card">
    <div class="zyc-card-t-l"></div>
    <div class="zyc-card-t-c"></div>
    <div class="zyc-card-b-l"></div>
    <div class="zyc-card-b-c"></div>
    <div class="zyc-card-c">
      <span :class="icon != ''?'zyc-card-img '+ icon:'zyc-card-img'"></span>
      <h1>{{ title }}</h1>
      <h2><count-to class="number_math_two" :startVal="0" :endVal="parseInt(number)" :duration="3000"></count-to><label v-if="units != ''">{{units}}</label></h2>
      <div style="clear:both;"></div>
    </div>
  </div>
</template>
<script>
  /**
  * 卡片容器
  */
  import CountTo from "vue-count-to"
  export default {
    name: 'zycCard',
    components: {
      CountTo
    },
    props: {
      icon: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      number: {
        type: Number,
        default: 0
      },
      units: {
        type: String,
        default: ''
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {
      
    },
    created() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/cardContainer.vue